const ROOT = "/"
const LOGIN = "/login"
const HOME = "/home"
const REDIRECTING = "/redirecting"
const PROFILE = "/profile"
const ADMINSATKER = "/admin-satker"
const PEGAWAI = "/pegawai"
const SATKER_PIMPINAN = "/satker-pimpinan"


export {
    ROOT,
    HOME,
    LOGIN,
    PROFILE,
    REDIRECTING,
    ADMINSATKER,
    PEGAWAI,
    SATKER_PIMPINAN
}